import ReactDOM from 'react-dom';
import { principalsSignupFormMain } from '../principalsSignupForm/principalsSignupFormMain.js';
import { detectLocation } from '../common/detectLocation.js';
import { StandaloneSearchBoxes } from '../common/StandaloneSearchBoxes.js';


$(() => {
    $('#email-contact-sign-up-widget').hide();

    detectLocation((location) => {
        ReactDOM.render(
            // baseSearchURL defined on jsp
            // eslint-disable-next-line no-undef
            <StandaloneSearchBoxes searchURL={baseSearchURL + '?historical=true'} baseSearchURL={baseSearchURL}
                detectedLocation={location} placeholder="Search districts, schools & teachers" />,
            document.getElementById('search-boxes'),
        );
    }, true);

    if (document.getElementById('principals-signup-form-main')) {
        principalsSignupFormMain();
    }
});
